import { createApp, type ObjectDirective} from 'vue'
import { createPinia } from 'pinia'
import { IMaskDirective } from 'vue-imask'
import App from './App.vue'
import router from './router'
import './assets/main.css'
import i18n from './Languages/i18n'
import { Icon } from '@iconify/vue'

const app = createApp(App)

app.directive('focus', {
  mounted: (el) => {
    el.focus()
  },
})

app.use(createPinia())
app.use(router)
app.use(i18n)
app.component('IconifyIcon', Icon)
app.directive('imask', IMaskDirective as unknown as ObjectDirective)

// app.use(VueQrcodeReader) // включишь, когда понадобится
app.mount('#app')
